<template>

  <section class="section">
    <!--div class="scanlines"></div-->
    <div class="glow"></div>
    <div id="header" class="container has-text-centered">
     <!--HelloWorld :msg="message"/-->
     <h1 class="title">c2h / ethynyl radical</h1>
     <p class="subtitle">
       sublim substanssymbolik
     </p>
    </div>

     <div class="container">
        <div class="columns">
           <div class="column is-4">
             <div class="has-text-centered">
               <img src="/img/rnd/still.svg" alt="still" title="Nonexistence; nonbeing; not having; a lack of, without." style="width:100px">
               <h6 class="title is-6">Digitala metamorfoser &amp; andliga psykoser</h6>
               <!--span>Yuyunipitqana</span-->
             </div>

             <div class="field has-addons" style="margin-top:20px">
               <div class="control">
                 <router-link to="/paintings" class="button is-dark">Paintings</router-link>
               </div>
               <div class="control">
                 <router-link to="/archive/1" class="button is-dark">Archive</router-link>
               </div>
               <div class="control">
                <router-link to="/dump/1" class="button is-dark">Dump</router-link>
              </div>
              <div class="control">
               <router-link to="/d/1" class="button is-dark">(D.)</router-link>
             </div>
             <div class="control">
              <router-link to="/pf" class="button is-dark">PF</router-link>
            </div>
             </div>
           </div>
           <div class="column">
             <div class="columns">
                 <div class="column">
                 <a href="/img/archive/c2h_m0GrrI.jpeg"><img src="/img/archive/c2h_m0GrrI.jpeg" alt="" /></a>
               </div>
               <div class="column">
                 <a href="/img/archive/1317310244-1.jpg"><img src="/img/archive/1317310244-1.jpg" alt="" /></a>
               </div>
               <div class="column">
                 <a href="/img/archive/c2h_z20xe1.jpeg"><img src="/img/archive/c2h_z20xe1.jpeg" alt="" /></a>
               </div>
             </div>
           </div>
        </div>
     </div>

     <div class="container">
      <div class="columns">
        <div class="column is-7">
          <TextList></TextList>
        </div>
        <div class="column is-5 has-text-right">
			<img src="/img/paintings/bliss.jpg"  />
        </div>
      </div>
    </div>

     <div class="container" id="glyph-wrapper">
		  <div class="columns is-centered">
			<div class="column is-half">
			  <Glyphs></Glyphs>
			</div>
		</div>
	 </div>

   <hr />
   <div class="columns">
     <div class="column is-12 has-text-centered">
         <a href="http://n.c2h.se/" target="_blank">// n.c2h.se ==></a>
         <a href="http://z.c2h.se/" target="_blank" style="margin-left:10px">%% z.c2h.se ==></a>
     </div>
   </div>
   <hr />

   <!--div class="container">
     <hr />
     <nav class="level">
       <div class="level-item has-text-centered">
         <div>
           <p class="heading">Tweets</p>
           <p class="title">3,456</p>
         </div>
       </div>
       <div class="level-item has-text-centered">
         <div>
           <p class="heading">Following</p>
           <p class="title">123</p>
         </div>
       </div>
       <div class="level-item has-text-centered">
         <div>
           <p class="heading">Followers</p>
           <p class="title">0.023K</p>
         </div>
       </div>
       <div class="level-item has-text-centered">
         <div>
           <p class="heading">Likes</p>
           <p class="title">789</p>
         </div>
       </div>
     </nav>
   </div-->


 </section>

</template>

<script>

import Glyphs from '@/components/Glyphs'
import TextList from '@/components/TextList'

export default {
  name: 'Home',
  components: {
    Glyphs,
    TextList
  },
  created() {

    //this.$buefy.snackbar.open(`POSITIVE AF!!`)

  }
}
</script>

<style scoped>
.scanlines {
    /*background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0.2) 70%, rgba(0, 0, 0, 0.6));
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(200, 200, 200, 0.1) 90%, rgba(128, 128, 128, 0.1));*/
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0.05) 100%, rgba(0, 0, 0, 0.6));
    background-size: 100% 0.25rem;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: -1;
}
.glow {
    /*background: radial-gradient(circle at center, #1bd459 0%, rgba(27, 212, 89, 0.88) 58%, rgba(21, 235, 92, 0.57) 80%, rgba(19, 94, 29, 0.27) 93%, rgba(10, 23, 12, 0) 100%);*/
  background: radial-gradient(circle at center, #fff 0%, rgba(212, 212, 212, 0.88) 58%, rgba(235, 235, 235, 0.57) 80%, rgba(19, 19, 19, 0.27) 93%, rgba(10, 10, 10, 0) 100%);

    opacity: 0.15;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    position: fixed;
}
#header {
  margin-bottom: 20px;
}
.field.has-addons {
  justify-content: center;
}
#glyph-wrapper {
  background: #111;
  margin-top: 20px;
  padding: 40px;
}
#glyph-wrapper .column {
  background: #fff;
}

</style>
